@defer (when clientConfig) {
  <div class="layout-wrapper" [ngClass]="containerClass()">
    <div client-sidebar></div>
    <div class="layout-content-wrapper">
      <div class="layout-content-wrapper-inside">
        <div client-topbar></div>
        <d2d-status-banner-strip />
        <div class="layout-content">
          <div app-breadcrumb></div>
          <router-outlet></router-outlet>
          <p-toast />
        </div>
        @if (items().length > 0) {
          <p-dock [model]="items()" position="bottom">
            <ng-template #item let-item>
              <a
                [pTooltip]="item.label"
                tooltipPosition="top"
                class="p-dock-item-link hover:bg-gray-500/20 transition-colors rounded-md cursor-pointer"
              >
                <img
                  [alt]="item.label"
                  [src]="item.icon"
                  class="w-7 h-7 object-contain cursor-pointer"
                />
              </a>
            </ng-template>
          </p-dock>
        }
        <div client-footer></div>
      </div>
    </div>
    <app-configurator />
    <!-- <div app-search></div> -->
    <!-- <div app-rightmenu></div> -->
    <div class="layout-mask animate-fadein"></div>
  </div>
}
